import * as React from "react";
import { useEffect } from "react";

import { useAuth } from "@/auth";
import { Button } from "@/components";
import routes from "@/constants/routes";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const filterLocalStorage = () => {
  const filteredData: Record<string, unknown> = {};
  const sensitiveKeys = ["okta-token-storage"];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && !sensitiveKeys.includes(key)) {
      filteredData[key] = localStorage.getItem(key);
    }
  }
  return filteredData;
};

export const AuthErrorComponent: React.FC<{ error: Error }> = ({ error }) => {
  useEffect(() => {
    Sentry.withScope((scope) => {
      scope.setExtras({ localStorage: filterLocalStorage() });
      scope.setTag("error-category", "auth-error");

      Sentry.captureException(error);
    });
  }, [error]);

  const { t } = useTranslation();
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated()) {
      navigate(routes.root);
    }
  }, [isAuthenticated, navigate]);

  return (
    <>
      <p>
        {error?.name || "Error"}: {error?.message || error.toString()}
      </p>
      <Button
        variant="yellow"
        className="h-5 rounded-lg uppercase shadow-yellow lg:px-9 lg:py-6 lg:text-sm"
        data-testid="login-button"
        onClick={login}
      >
        <p>{t("navbar.logIn")}</p>
      </Button>
    </>
  );
};
